import SolarIcon from 'components/icons/SolarIcon';
import { getBaseCurrencySymbol, getCurrencySymbol } from 'utils/helpers/currency/currencyHelpers';
import DashAction from './DashAction';
import { formatPlainAmount, rateTitle } from '../model';
import type { AnalyticsDashMetric } from '../model';

const TILE_TONES = ['materials', 'services', 'extra', 'other'];

interface DashMetricTileProps {
    isUahMode: boolean;
    metric: AnalyticsDashMetric;
}

const amountClass = (amount: number, zeroClass: string) => {
    if (amount > 0) return 'text-success';
    if (amount < 0) return 'text-danger';
    return zeroClass;
};

const DashMetricTile = ({ isUahMode, metric }: DashMetricTileProps) => {
    const disabled = Boolean(metric.disabled);
    const secondary = disabled ? null : metric.secondaryAmount;
    const currencySymbol = isUahMode ? getCurrencySymbol() : getBaseCurrencySymbol();
    const toneClass =
        !disabled && TILE_TONES.includes(metric.key) ? ` object-analytics-dash__tile--${metric.key}` : '';

    return (
        <li
            className={`object-analytics-dash__tile${toneClass}${disabled ? ' is-disabled' : ''}`}
            aria-disabled={disabled || undefined}
        >
            {metric.icon ? (
                <span className="object-analytics-dash__tile-icon text-muted" aria-hidden="true">
                    <SolarIcon name={metric.icon} />
                </span>
            ) : null}
            <div className="object-analytics-dash__tile-body">
                <div className="object-analytics-dash__tile-head">
                    <span
                        className="object-analytics-dash__tile-label object-analytics-dash__tile-label--currency text-muted"
                        title={`${metric.label} ${currencySymbol}`}
                    >
                        <span className="text-truncate">{metric.label}</span>
                        <span className="object-analytics-dash__tile-currency">{currencySymbol}</span>
                    </span>
                    {!disabled && metric.actionLabel && metric.onAction ? (
                        <DashAction label={metric.actionLabel} onClick={metric.onAction} />
                    ) : null}
                </div>
                {disabled ? (
                    <span className="object-analytics-dash__tile-amount text-muted">—</span>
                ) : (
                    <span
                        className={`object-analytics-dash__tile-amount ${amountClass(metric.amount, 'text-body')}`}
                        title={rateTitle(isUahMode, metric.rateTitle)}
                    >
                        {formatPlainAmount(metric.amount, true)}
                    </span>
                )}
                {secondary ? (
                    <span
                        className={`object-analytics-dash__tile-sub ${amountClass(secondary, 'text-muted')}`}
                        title={rateTitle(isUahMode, metric.secondaryRateTitle)}
                    >
                        {formatPlainAmount(secondary)}
                    </span>
                ) : null}
            </div>
        </li>
    );
};

export default DashMetricTile;
